import React from "react";
import { Link } from "react-router-dom";
import { FaPhoneAlt, FaEnvelope, FaClock } from "react-icons/fa";
import SocialLinks from "./SocialLinks";
import logo from "../../assets/public/logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer id="main-footer" className="bg-gray-800 text-gray-300 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Coluna 1: Sobre */}
          <div className="mb-6 md:mb-0">
            <div className="flex items-center mb-4">
              <img 
                src={logo} 
                alt="Hadritech Logo" 
                className="h-10 w-auto max-w-[180px] object-contain" 
              />
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Tecnologia especializada para tornar a experiência de RH com TOTVS Protheus mais inteligente, produtiva e conectada.
            </p>
            <SocialLinks />
          </div>

          {/* Coluna 2: Links Rápidos */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-white text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Links Rápidos</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Início</Link></li>
              <li><a href="/#rh-copilot" className="text-gray-400 hover:text-white transition-colors">RH Copilot</a></li>
              <li><a href="/#portal-rh" className="text-gray-400 hover:text-white transition-colors">Portal RH</a></li>
              <li><Link to="/contato" className="text-gray-400 hover:text-white transition-colors">Contato</Link></li>
            </ul>
          </div>

          {/* Coluna 3: Serviços */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-white text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Nossos Serviços</h3>
            <ul className="space-y-2">
              <li><span className="text-gray-400">RH Copilot</span></li>
              <li><span className="text-gray-400">Portal RH Hadritech</span></li>
              <li><span className="text-gray-400">Consultoria Protheus RH</span></li>
              <li><span className="text-gray-400">Implantações e customizações</span></li>
            </ul>
          </div>

          {/* Coluna 4: Contato */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Entre em Contato</h3>
            <ul className="space-y-3">
              <li className="flex items-center">
                <FaPhoneAlt className="text-indigo-400 mr-3" />
                <a href="tel:+5511954938127" className="text-gray-400 hover:text-white transition-colors">(11) 95493-8127</a>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-indigo-400 mr-3" />
                <a href="mailto:contato@hadritech.com.br" className="text-gray-400 hover:text-white transition-colors">contato@hadritech.com.br</a>
              </li>
              <li className="flex items-center">
                <FaClock className="text-indigo-400 mr-3" />
                <span className="text-gray-400">Seg - Sex: 7:00 - 21:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Direitos Autorais */}
        <div className="border-t border-gray-700 pt-6 mt-8 text-center text-gray-500 text-sm">
          <p>&copy; {currentYear} Hadritech. Todos os direitos reservados.</p>
          <div className="mt-2 text-xs">
            <span className="mx-2">Política de Privacidade</span>
            <span>•</span>
            <span className="mx-2">Termos de Uso</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
